// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"734237e5","374":"05698099","438":"709badd2","453":"046f2d16","466":"573221e2","507":"3f134400","801":"6c5491f1","961":"6de3519e"}[chunkId] + ".chunk.js";
};